import React, { useState, useEffect } from "react";

import { MdEditLocationAlt } from "react-icons/md";
import { AiFillCar } from "react-icons/ai";
import moment from "moment";
import { BsPersonFill } from "react-icons/bs";
import { MdPayment } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { MdLocationOn } from "react-icons/md";
import Swal from "sweetalert2";

import { MdDateRange } from "react-icons/md";
import logo from "./../../assets/images/logo.png";
import { IoMdBus } from "react-icons/io";
import { loginCustomer } from "../../redux/CustomerReducer";

import { useDispatch } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import { useSelector } from "react-redux";
import { registerCustomer } from "../../redux/CustomerReducer";
// import { setObjBookingDet } from "../../redux/CustomerReducer";
import "./RegisterBook.css";
import { Link } from "react-router-dom";
const RegisterBook = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [wantLogin, setWantLogin] = useState(false);
  const dispatch = useDispatch();
  const bookingDataRed=useSelector((state)=>state?.CustomerReducer?.setObjBookingDetData);
  console.log("bookingDataRed",bookingDataRed)
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  console.log("user", user);

  const nextClicked =async () => {

    const user1 = {
      email: user.email,
      password: user.password,
    };
    const response = await dispatch(loginCustomer(user1));

    if (response.payload.status) {
      Swal.fire("Good", response?.payload?.message, "success");

      navigate("/payment");
    }
  };

  const alreadyRegisClicked = async () => {
    setWantLogin(!wantLogin);
  };
  const registerUser = async () => {

    dispatch(registerCustomer(user));
    setWantLogin(!wantLogin);

   
  };

  useEffect(() => {
    // simulate an async action
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []); // pass an empty array to only run this effect once
  return (
    <>
      <div>
        {isLoading ? (
          <div className="mainContainerLoader">
            <img src={logo} className="logoAlertImg" />

            {/* <div className="alertTxt">Please wait .....</div> */}

            <div className="topLoaderIconsAlert">
              <IoMdBus className="busIcon" />
              <BiLoaderAlt className="loaderIconAlert" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="topMainStepperFields">
        <div className="bookingDetailRegisMain">
          <div>
            <div className="locAdddresMainReg">
              <div className="topLocationMd">
                <MdLocationOn />
              </div>

              <div className="pickDresRegBkTxt">
                {bookingDataRed?.pickUpLocation}
              </div>
            </div>
          </div>
          <div className="topDateRange">
            <MdDateRange />
            <span>{bookingDataRed?.pickUpTime}, {moment(bookingDataRed?.pickUpDate).format("YYYY-MM-DD")}
            </span>
          </div>
          <div>
            <div className="locAdddresMainReg locAdddresMainRegSeconCol">
              <div className="topLocationMd topLocationMdSecColor">
                <MdLocationOn />
              </div>

              <div className="pickDresRegBkTxt pickDresRegBkTxtSecColor">
               {bookingDataRed?.pickUpLocation}
              </div>
            </div>
          </div>
        </div>

        <div className="mainStepper">
          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle">
                <MdEditLocationAlt className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Journey</div>
            </div>
            <div className="stepperLine"></div>
          </div>
          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle">
                <AiFillCar className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Vehicle</div>
            </div>
            <div className="stepperLine"></div>
          </div>
          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle">
                <BsPersonFill className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Registration</div>
            </div>
            <div className="stepperLine stepperLineColorless"></div>
          </div>
          <div className="topStepperSingle">
            <div className="topIconDesc">
              <div className="stepperCircle stepperCircleColorless">
                <MdPayment className="iconStepper" />
              </div>
              <div className="steppeBtmTxt">Payment</div>
            </div>
          </div>
        </div>

        <div className="mainContainerRegister">
          {wantLogin && (
            <>
              <div className="topInputFields">
                <div className="topLableInput">
                  <div className="labelTxt">Name</div>
                  <input
                    placeholder="john"
                    className="inputField"
                    name="name"
                    onChange={handleChange}
                  />
                </div>
                <div className="topLableInput">
                  <div className="labelTxt">Mobile Number</div>
                  <input
                    placeholder="Mobile Number"
                    className="inputField"
                    name="phone"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="topInputFields">
                <div className="topLableInput">
                  <div className="labelTxt">Email Address</div>
                  <input
                    placeholder="john@gmail.com"
                    className="inputField"
                    name="email"
                    onChange={handleChange}
                  />
                </div>
                <div className="topLableInput">
                  <div className="labelTxt">Password</div>
                  <input
                    placeholder="Enter Password"
                    className="inputField"
                    name="password"
                    onChange={handleChange}
                    type="password"
                  />
                </div>
              </div>
            </>
          )}

          {!wantLogin && (
            <div className="topInputFields topInputFieldsLogin">
              <div className="topLableInput">
                <div className="labelTxt">Email Address</div>
                <input
                  placeholder="john@gmail.com"
                  className="inputField"
                  name="email"
                  onChange={handleChange}
                />
              </div>
              <div className="topLableInput">
                <div className="labelTxt">Password</div>
                <input
                  placeholder="Enter Password"
                  className="inputField"
                  name="password"
                  onChange={handleChange}
                  type="password"
                />
              </div>
            </div>
          )}
          <div className="mainR3RegisterBook">
            <input type="checkbox" />
            <div className="acceptTempTxt">
              {" "}
              Please accept our <span> Terms & Conditions.</span>
            </div>
          </div>
          <div className="mainR4RegisterBook">
           {!wantLogin&& <button className="btnNext" onClick={nextClicked}>
          Login
            </button>}
            {wantLogin ? (
            <button className="btnAlreadyReg" onClick={registerUser}>
            Create Account
          </button>
            ) : (
              <button className="btnAlreadyReg" onClick={alreadyRegisClicked}>
                Create Account
              </button>
            )}

            <Link to="/payment">
              <button className="btnGuest">Guest Login</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterBook;
